import { Icon } from "~/components/ui/icon";

export type DestinationIconName =
  | "overview"
  | "evidence"
  | "sources"
  | "proposals"
  | "rulesets"
  | "rules"
  | "calculator"
  | "calculations"
  | "lots"
  | "invoices"
  | "verification"
  | "audit"
  | "settings"
  | "users"
  | "legal"
  | "agents"
  | "webResearch"
  | "demos"
  | "howItWorks"
  | "agentFindings"
  | "uploadFailures"
  | "sessions"
  | "infraCost"
  | "autoApproval"
  | "key"
  | "logs"
  | "book"
  | "lab";

/** Group headings: shown as the rail icon when the sidebar is collapsed. */
export type GroupIconName = "governance" | "automation" | "admin";

export type ModeIconName = "operations" | "developers";

export type NavIconName =
  | DestinationIconName
  | GroupIconName
  | "panel"
  | "operations"
  | "developers"
  | "back"
  | "check"
  | "chevron"
  | "lab"
  | "video"
  | "quiz";

/**
 * Navigation names are a subset of the shared catalogue in
 * `components/ui/icon.tsx`; this wrapper keeps the historical API.
 */
export function NavIcon({ name, className }: { name: NavIconName; className?: string }) {
  return <Icon name={name} className={className} />;
}
